import {Subject, throwError as observableThrowError} from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import {Injectable, isDevMode} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';


import {ToastrService} from 'ngx-toastr';
// import * as webNotification from 'simple-web-notification';
import {NavigationEnd, Router} from '@angular/router';
import {MyCONST} from '../CONST/myCONST';
import {NgxSpinnerService} from 'ngx-spinner';

@Injectable()
export class RequestService {
  url = 'assets/data/generated.json';
  displayNavigationBar = true;
  private _isConnected = false;
  that = this;
  currentURL = '';


  userTransmitter = new Subject(); // new BehaviorSubject<any>('map');
  userProfileObservable = this.userTransmitter.asObservable();

  constructor(private http: HttpClient, private toastr: ToastrService,
              private router: Router, private spinner: NgxSpinnerService) {
    const tt = this;

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        tt.currentURL = event.url.split('/')[1];
      }
    });
  }

  userProfileChangeListener(message: any) {
    this.userTransmitter.next(message);
  }

  hideSpinner() {
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
    }, 700);
  }

  showSpinner() {
    this.spinner.show();
  }

  get(_url, spinner = false) {
    if (spinner) {
      this.spinner.show();
    }
    const env = isDevMode() ? 'test' : 'live';
    const token = 'Bearer ' + localStorage.getItem(MyCONST.Token);
    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': token,
      // 'Access-Control-Allow-Origin': '*',
      // 'Access-Control-Allow-Methods': 'GET'
    });

    return this.http.get(_url, {headers: headers, responseType: 'json'}).pipe(
      catchError(this.errorHandler.bind(this)));
  }


  get2(_url) {
    const token = 'Bearer ' + localStorage.getItem(MyCONST.Token);
    this.spinner.show();

    const headers = new HttpHeaders({
      'Accept': 'application/json',
      Authorization: token
    });

    return this.http.get(_url, {headers: headers, responseType: 'json'}).pipe(
      catchError(this.errorHandler.bind(this)));
  }


  post(requestURL, body, json_only = false) {
    this.spinner.show();
    const token = 'Bearer ' + localStorage.getItem('_token');

    let headers = new HttpHeaders({
      'Accept': 'application/json',
      Authorization: token
    });

    if (json_only) {
      headers = new HttpHeaders({
        'Accept': 'application/json',
        Authorization: token,
        'Content-Type': 'application/json',
      });
    }
    return this.http.post(requestURL, body, {headers: headers, responseType: 'json'})
      .pipe(catchError(this.errorHandler.bind(this)));
  }

  async_post(requestURL, body, json_only = false) {
    const token = 'Bearer ' + localStorage.getItem('_token');
    let headers = new HttpHeaders({
      'Accept': 'application/json',
      Authorization: token
    });

    if (json_only) {
      headers = new HttpHeaders({
        'Accept': 'application/json',
        Authorization: token,
        'Content-Type': 'application/json'
      });
    }

    return this.http.post(requestURL, body, {headers: headers, responseType: 'json'})
      .pipe(catchError(this.errorHandler.bind(this)));
  }

  delete(requestURL) {
    this.spinner.show();
    const token = 'Bearer ' + localStorage.getItem('_token');

    const headers = new HttpHeaders({
      'Accept': 'application/json',
      Authorization: token,
    });

    return this.http.delete(requestURL, {headers: headers, responseType: 'json'})
      .pipe(catchError(this.errorHandler.bind(this)));
  }

  put(requestURL, body, json_only = false) {
    this.spinner.show();
    const token = 'Bearer ' + localStorage.getItem('_token');

    let headers = new HttpHeaders({
      'Accept': 'application/json',
      Authorization: token,
      // 'Cache-Control': 'no-cache',
      // 'Pragma': 'no-cache',
      // 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT',
    });

    if (json_only) {
      headers = new HttpHeaders({
        'Accept': 'application/json',
        Authorization: token,
        'Content-Type': 'application/json',
      });
    }


    return this.http.put(requestURL, body, {headers: headers, responseType: 'json'})
      .pipe(catchError(this.errorHandler.bind(this)));
  }

  async_put(requestURL, body, json_only = false) {
    const token = 'Bearer ' + localStorage.getItem('_token');
    let headers = new HttpHeaders({
      'Accept': 'application/json',
      Authorization: token,
      // 'Cache-Control': 'no-cache',
      // 'Pragma': 'no-cache',
      // 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT',
    });

    if (json_only) {
      headers = new HttpHeaders({
        'Accept': 'application/json',
        Authorization: token,
        'Content-Type': 'application/json',
      });
    }


    return this.http.put(requestURL, body, {headers: headers, responseType: 'json'})
      .pipe(catchError(this.errorHandler.bind(this)));
  }


  download(_url) {
    const env = isDevMode() ? 'test' : 'live';
    const token = 'Bearer ' + localStorage.getItem('_token');

    const headers = new HttpHeaders({
      'env': env,
      Authorization: token
    });

    return this.http.get(_url, {headers: headers, responseType: 'blob'}).pipe(
      catchError(this.errorHandler.bind(this)));
  }

  getT(_url) {
    return this.http.get(_url, {responseType: 'text'}).pipe(
      catchError(this.errorHandler));
  }

  errorHandler(error: HttpErrorResponse) {
    try {
      setTimeout(() => {
        /** spinner ends after 5 seconds */
        this.spinner.hide();
      }, 700);
    } catch (e) {
      console.log('error spinner', e);
    }
    // alert(error.message || 'Server Error');
    return observableThrowError(error.message || 'Server Error');
  }


  search(url, key: string) {
    return this.http.get(url + '?Q=' + key).pipe(map((resp: Response) => {
      return resp;
    }), catchError(this.errorHandler));
  }

  notifySuccess(type, title, message) {
    this.hideSpinner();
    // success/error/warning/info/show
    this.toastr[type](message, title, {
      progressBar: false, progressAnimation: 'decreasing', // increasing
      enableHtml: true, closeButton: true, tapToDismiss: true,
      extendedTimeOut: 5000,
      timeOut: 8000
    }); //
  }

  notifyMessage(type, title, message) {
    // success/error/warning/info/show
    this.toastr[type](message, title, {
      progressBar: false, progressAnimation: 'decreasing', // increasing
      enableHtml: true, closeButton: true, tapToDismiss: true,
      extendedTimeOut: 3000,
      timeOut: 4000
    }); //
  }


  checkConnected() {
    setTimeout(() => {
      if (!this.isConnected) {
        this.notifySuccess('error', 'Notification', 'Please connect first');
        this.router.navigate(['/fplogin']);
      }
    }, 0);

  }

  get isConnected(): boolean {
    const local = localStorage.getItem('isConnected');

    if (local) {
      this._isConnected = JSON.parse(local);
      console.log('localstorage value : ' + local);

      return this._isConnected;
    } else {
      return false;
    }
  }

  set isConnected(value: boolean) {
    this._isConnected = value;
    localStorage.setItem('isConnected', JSON.stringify(value));
  }


}
